
  $(document).ready(function(){
    var minSlideValue = 5;
    var width_value = $(window).width();
    if(width_value <= 600 ){
      minSlideValue = 2;
    }else if(width_value <= 1024 && width_value >= 600){
      minSlideValue = 4;
    }
    //console.log(width_value);
    $('.example__slider').bxSlider({
      auto: true,
      pager:false,
      infiniteLoop:true,
      controls:true,
      minSlides: minSlideValue,
      maxSlides: 5,
      mode: 'horizontal',
      adaptiveHeight: true,
      slideWidth: 300,
      moveSlides: 1,
      responsive:true,
      speed:100,
      nextText: '<img src="https://cdn.shopify.com/s/files/1/0052/9308/0674/t/4/assets/next.png?v=1626630130" height="25" width="25"/>',
      prevText: '<img src="https://cdn.shopify.com/s/files/1/0052/9308/0674/t/4/assets/prev.png?v=1626629971" height="25" width="25"/>'
    });
  });
$(window).ready(function(){
  $(".product-slider .font--section-heading").hide(); 
  $(".product-grid--root").hide(); 
    setTimeout(function(){ 
        $(".product-slider .font--section-heading").show(); 
        $(".product-grid--root").show(); 
    },1000); 
});
$(function() {
  var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}
  
  //$(".enquiry-button__button").click({
   // $('#myModal').on('shown.bs.modal', function () {
    //  $('#myInput').trigger('focus')
   // })
    /*
    var enquiry_module;
        
        enquiry_module = $("<div id='enquiry_module'></div>").append($(".popup--root"));
        return enquiry_module;
  
  
  */
//  });

});
/*
window.onload = function() {
  var intervalHandler = setInterval(checkSliderLoad, 1000);

  function checkSliderLoad() {
    if($(".slides.owl-carousel .image--root .image--container img").length>0){
      $(".slides.owl-carousel .image--root .image--container img").each(function( index ) {
          $that=$(this);
          var imgsrcset=$that.attr("srcset");
          maxVal=0;
          imgPath="";
        
          if(imgsrcset!="")
         	{
            	imgsrcset = imgsrcset.split(", ");      

            	$.each(imgsrcset, function( index, value ) {
                  valueArray = value.split(" ");
                  if(maxVal<parseInt(valueArray[1].replace("w",""))){
                      maxVal=parseInt(valueArray[1].replace("w",""));
                      imgPath=valueArray[0];                      
                   }
	              });
              if(imgPath!=""){
                	stopIntervalFunction();
                  	$that.parents(".slides.owl-carousel .image--container").css("background-image", "url('"+imgPath+"')");
                  	$that.remove();
              }
          }
      });

    }
  }

  function stopIntervalFunction() {
    clearInterval(intervalHandler);
  }
};
*/